import { render, staticRenderFns } from "./reports.page.vue?vue&type=template&id=ade9c594&scoped=true&"
import script from "./reports.page.vue?vue&type=script&lang=js&"
export * from "./reports.page.vue?vue&type=script&lang=js&"
import style0 from "./reports.page.vue?vue&type=style&index=0&id=ade9c594&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade9c594",
  null
  
)

export default component.exports